import type { ApiResponse } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('auth_token');

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  if (window.Telegram?.WebApp?.initData) {
    (headers as Record<string, string>)['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, { ...options, headers });
  const data: ApiResponse<T> = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unknown error');
  }

  return data.data as T;
}

// ============================================
// CHRONICLE TYPES
// ============================================

export interface ChronicleEntry {
  id: string;
  triggerType: string;
  triggerData: Record<string, unknown>;
  narrative: string;
  fatigueBefore: number | null;
  fatigueAfter: number | null;
  mood: string | null;
  createdAt: string;
}

export interface ChronicleListResponse {
  entries: ChronicleEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// ============================================
// API CALLS
// ============================================

export async function getChronicleEntries(page: number = 1, limit: number = 10): Promise<ChronicleListResponse> {
  return request<ChronicleListResponse>(`/chronicle?page=${page}&limit=${limit}`);
}

export async function getLatestChronicleEntry(): Promise<ChronicleEntry | null> {
  return request<ChronicleEntry | null>('/chronicle/latest');
}
